import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from './Modal';

export const ProductEnergyIcon = (props) => {
  const { imageUrl, iconClassName } = props;

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => {
          setIsOpen(true);
        }}
        className={`product-detail__energy-icon ${iconClassName}`}
      ></button>

      <Modal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      >
        <img src={imageUrl} className='product-detail__energy-image w-[300px] max-w-full' />
      </Modal>
    </>
  );
};

ProductEnergyIcon.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  iconClassName: PropTypes.string.isRequired,
};
